import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
export var useFirstRenderHistoryLogic = function useFirstRenderHistoryLogic() {
  var location = useLocation();
  useEffect(function () {
    var handleNavigation = function handleNavigation() {
      window.USE_FIRST_RENDER = false;
    };

    // Initial render should set the window.USE_FIRST_RENDER
    handleNavigation();
    return function () {
      window.USE_FIRST_RENDER = false;
    };
  }, [location]);
};
var useFirstRender = function useFirstRender() {
  var _window$USE_FIRST_REN;
  var defaultValue = __IS_SSR__ ? false : (_window$USE_FIRST_REN = window.USE_FIRST_RENDER) !== null && _window$USE_FIRST_REN !== void 0 ? _window$USE_FIRST_REN : true;
  var _useState = useState(defaultValue),
    isFirstRender = _useState[0],
    setIsFirstRender = _useState[1];
  useEffect(function () {
    var updateState = function updateState() {
      setIsFirstRender(window.USE_FIRST_RENDER);
    };
    updateState();
    return function () {
      setIsFirstRender(false);
    };
  }, []);
  return isFirstRender;
};
export default useFirstRender;